export const ProductBookingAsClientPriceSection = [
    {
        title: "מחיר הזמנה",
        key: "offeredPrice"
    },
    {
        title: "מחיר משלוח",
        key: "deliveryPrice"
    },
    {
        title: "הנחה כללית",
        key: "companyDiscount"
    }
];
